import React, { useEffect, useState } from 'react'


function ViewProfilePic({user}) {
    const [profilePic, setProfilePic] = useState([])

    useEffect(() => {

        console.log(user, "");
        setProfilePic(user.image)
    }, []);

   
  return (
    <>
    <div style={{textAlign:"center"}}>
    <img src={`data:image/jpeg;base64,${profilePic}`} alt="Red dot" width="20%" height="30%" />
    </div>
    </>
  )
}

export default ViewProfilePic